/**
 * Compare two semver strings (e.g. "1.2.3").
 * Returns: -1 if a < b, 0 if a === b, 1 if a > b.
 * Non-numeric parts (e.g. "-beta") are stripped; missing segments treated as 0.
 */
export function compareSemver(a, b) {
  if (!a || !b) return 0
  const parse = (s) => {
    const numPart = String(s).split(/[-+]/)[0].trim()
    return numPart.split('.').map((n) => parseInt(n, 10) || 0)
  }
  const pa = parse(a)
  const pb = parse(b)
  for (let i = 0; i < 3; i++) {
    const na = pa[i] ?? 0
    const nb = pb[i] ?? 0
    if (na < nb) return -1
    if (na > nb) return 1
  }
  return 0
}
